import React from 'react';

const Mail = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.5 4.5L6.68477 7.43773C8.5962 8.52076 9.4038 8.52076 11.3152 7.43773L16.5 4.5",
      stroke: "#BFBFBF",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.51182 10.1067C1.56086 12.4059 1.58537 13.5554 2.43372 14.407C3.28206 15.2586 4.46275 15.2883 6.82412 15.3476C8.27948 15.3841 9.72052 15.3841 11.1759 15.3476C13.5373 15.2883 14.7179 15.2586 15.5663 14.407C16.4146 13.5554 16.4391 12.4059 16.4882 10.1067C16.5039 9.36745 16.5039 8.63256 16.4882 7.8933C16.4391 5.59415 16.4146 4.44457 15.5663 3.593C14.7179 2.74142 13.5373 2.71176 11.1759 2.65243C9.72052 2.61586 8.27948 2.61586 6.82412 2.65242C4.46275 2.71175 3.28206 2.74141 2.43371 3.59299C1.58537 4.44456 1.56085 5.59413 1.51182 7.89328C1.49606 8.63255 1.49606 9.36745 1.51182 10.1067Z",
      stroke: "#BFBFBF",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }
  )
);

export { Mail };
//# sourceMappingURL=Mail.js.map
